module.exports = __webpack_public_path__ + "img/BankID_logo.002592fa.png";